export default "__VITE_ASSET__BLZ2oScj__"